var _g, _g2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFemale = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0416\\u0456\\u043D\\u043E\\u0447\\u0456",
    width: 43.799,
    height: 65,
    viewBox: "0 0 43.799 65",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-1",
    d: "M105.4,0a21.9,21.9,0,0,0-3.809,43.467v6.172H97.655a3.809,3.809,0,0,0,0,7.617h3.936v3.936a3.809,3.809,0,0,0,7.617,0V57.256h3.936a3.809,3.809,0,0,0,0-7.617h-3.936V43.467A21.9,21.9,0,0,0,105.4,0Zm2.728,41.709a.952.952,0,0,0-.823.943v7.939a.952.952,0,0,0,.952.952h4.888a1.9,1.9,0,0,1,0,3.809h-4.888a.952.952,0,0,0-.952.952v4.888a1.9,1.9,0,0,1-3.809,0V56.3a.952.952,0,0,0-.952-.952H97.655a1.9,1.9,0,0,1,0-3.809h4.888a.952.952,0,0,0,.952-.952V42.652a.952.952,0,0,0-.823-.943,20,20,0,1,1,5.455,0Z",
    transform: "translate(-83.5)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(5.732 5.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-1",
    d: "M144.668,45a15.964,15.964,0,0,0-9.914,3.412.958.958,0,0,0-.167,1.34.948.948,0,0,0,1.335.168,14.085,14.085,0,0,1,8.747-3.009A14.3,14.3,0,1,1,133.4,52.454a.958.958,0,0,0-.167-1.34.948.948,0,0,0-1.335.168A16.153,16.153,0,1,0,144.668,45Z",
    transform: "translate(-128.5 -45)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFemale, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/female.3f45b1c1.svg";
export { ForwardRef as ReactComponent };